<template>
    <button class="selfservice-button"
            :class="[classArr, 'selfservice-button--' + color, showUndo ? 'show-undo': '']"
            :disabled="isDisabled"
            :color="color"
            :height="height"
            :id="buttonId"
            :style="{'min-width': minWidth + 'px', 'max-width': showUndo ? minWidth + 'px' : ''}"
            @click="btnClicked($event)">
        <span :style="{ color: textColor }" :class="{'text-uppercase': labelUpperCase}">
            {{ showUndo ? 'Undo ' + label + ' ' + timer + 's' : label }}
        </span>
    </button>
</template>

<script>
    export default {

        props: {
            label: { type: String },
            classArr: { type: Object },
            isDisabled: { type: Boolean },
            applyUndo: { type: Boolean },
            undoTimeInSeconds: { type: Number, default: 5 },
            width: String | Number,
            color: String,
            labelUpperCase: { type: Boolean },
            minWidth: String | Number,
            height: String | Number,
            textColor: { type: String },
        },
        data() {
            return {
                buttonId: 'button-' + this.uuidv4(),
                showUndo: false,
                timer: this.undoTimeInSeconds,
                undoTimeout: {},
                timerInterval: {}
            }
        },
        methods: {
            btnClicked() {
                if (this.applyUndo) {
                    this.showUndo = !this.showUndo;
                    let closestCardContainer = document.getElementById(this.buttonId).closest('.card-container');
                    if (this.showUndo) {
                        $('button').prop('disabled', true);
                        $('#' + this.buttonId).prop('disabled', false);
                        closestCardContainer.classList.add('undo-activated');
                        this.startTimer(this.undoTimeInSeconds);
                        this.undoTimeout = setTimeout(() => {
                            this.$emit('click', this);
                            this.showUndo = false;
                            closestCardContainer.classList.remove('undo-activated');
                            clearTimeout(this.undoTimeout);
                            $('button').prop('disabled', false);
                        }, this.undoTimeInSeconds * 1000);
                    } else {
                        $('button').prop('disabled', false);
                        clearTimeout(this.undoTimeout);
                        clearInterval(this.timerInterval);
                        closestCardContainer.classList.remove('undo-activated');
                    }

                } else {
                    this.$emit('click', this);
                }
            },

            mouseover() {
                this.$emit('mouseover');
            },

            mouseleave() {
                this.$emit('mouseleave');
            },

            startTimer(duration) {
                let seconds = duration;
                this.timer = duration;
                this.timerInterval = setInterval(() => {
                    seconds--;
                    this.timer = seconds;
                    if (seconds <= 0) {
                        clearInterval(this.timerInterval);
                    }
                }, 1000);
            },

            uuidv4() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }
        }
    }

</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/ApproveDashboard/button.vue